// extracted by mini-css-extract-plugin
export var modal = "_tp-0";
export var table = "_tp-1";